import { combineEpics, Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import * as types from './types';
import { notify } from '../../../services/notifier.service';

const TableEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.FETCH_TABLE),
    mergeMap((action) =>
      loopBackApi()
        .get(action.payload.endPoint, action.payload.filters)
        .then((res) => ({
          type: types.FETCH_TABLE_FULFILLED,
          payload: {
            data: res.data,
            stateKey: action.payload.stateKey,
            filters: action.payload.filters
          }
        }))
        .catch((err) => {
          notify({
            title: 'Helaas',
            html: `Op dit moment kan de data helaas niet worden opgehaald. Probeer het later nogmaals`,
            type: 'error'
          });
          return {
            type: types.FETCH_TABLE_ERROR,
            payload: { stateKey: action.payload.stateKey, filters: action.payload.filters }
          };
        })
    )
  );
export const tableEpics = combineEpics(TableEpic);
